<template>
  <div class="hamburger hamburger--boring" :class="{'is-active': open}" @click="toggle">
    <div class="hamburger-box">
      <div class="hamburger-inner"></div>
    </div>
  </div>
</template>
<script>
import 'hamburgers/dist/hamburgers.min.css';

export default {
  props: ['open'],
  methods: {
    toggle() {
      // this.isActive = !this.isActive;
      this.$emit('toggle', !this.open);
    },
  },
};
</script>
